__turbopack_context__.v({
  "body": "oX2ira_body",
  "hint": "oX2ira_hint",
  "link": "oX2ira_link",
});
